import React from 'react';
import { motion } from 'framer-motion';
import { Helmet } from "react-helmet-async";

import Hero from '../components/home/Hero';
import Services from '../components/home/Services';
import FeaturedProjects from '../components/home/FeaturedProjects';
import AboutPreview from '../components/home/AboutPreview';
import Testimonials from '../components/home/Testimonials';
import ContactSection from '../components/home/ContactSection';

import './HomePage.css';

const HomePage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="home-page"
    >

      {/* ✅ SEO (VERY IMPORTANT) */}
      <Helmet>
        <title>ZustandTech | Best Software Development Company in India</title>
        <meta
          name="description"
          content="ZustandTech (Zustand Tech Software Private Limited) is a leading and best software development company in India, delivering web development, mobile apps, AI solutions, and cloud services for startups and businesses worldwide."
        />
        <meta name="keywords" content="ZustandTech, Zustand Tech Software Private Limited, best software company in India, top software development company India, software development company India, web development, mobile app development, AI solutions, cloud services" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.zustandtech.com/" />
      </Helmet>

      {/* ✅ H1 (Google Ranking Factor) */}
      <h1 style={{ display: "none" }}>
        ZustandTech (Zustand Tech Software Private Limited) - Best Software Development Company in India
      </h1>

      {/* Your Sections */}
      <Hero />
      <Services />
      <FeaturedProjects />
      <AboutPreview />
      <Testimonials />
      <ContactSection />

    </motion.div>
  );
};

export default HomePage;